export default __webpack_public_path__ + "static/nuno-93c1ff09416d662ecce4a83c094e9b6a.jpg";